<div class="container">
  <p class="pill" [ngClass]="statusClass">{{ status }}</p>
</div>
